import { deserialize, Expose, Serializable } from '@tokeet/tv3-platform'

export class Note extends Serializable<Note> {
  @Expose({ name: 'key' })
  id: string

  note: string
  timestamp: number
  user: string

  static deserialize(data: object): Note {
    return deserialize(Note, data)
  }
}
